module.exports = __webpack_public_path__ + "arrow_forward-86d9631119bdad787c8bf16414bb7a2e.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/DocumentsTable/Images/arrow_forward.png
// module id = WTkQ
// module chunks = client